type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

interface WelcomeMessage {
    title: string;
    subtitle: string;
}

// Obtenir le moment de la journée
const getTimeOfDay = (): TimeOfDay => {
    const hour = new Date().getHours();
    if (hour >= 6 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 18) return 'afternoon';
    if (hour >= 18 && hour < 22) return 'evening';
    return 'night';
};

// Messages par moment de la journée
const messagesByTime: Record<TimeOfDay, Array<{ title: (name: string) => string; subtitle: string }>> = {
    morning: [
        { title: (name) => `Bonjour ${name}`, subtitle: "Quelles arcanes du droit vous intéressent ?" },
        { title: (name) => `Belle matinée, ${name}`, subtitle: "Une question juridique à éclaircir ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Je suis à votre disposition." },
        { title: (name) => `Bien le bonjour, ${name}`, subtitle: "Explorons le droit ensemble." },
        { title: (name) => `Bonjour ${name}`, subtitle: "Comment puis-je vous assister ?" },
        { title: (name) => `Excellente matinée, ${name}`, subtitle: "Quel sujet juridique vous préoccupe ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Prêt à naviguer dans le droit français." },
        { title: (name) => `Bonjour ${name}`, subtitle: "Une recherche juridique en tête ?" },
        { title: (name) => `Ravi de vous retrouver, ${name}`, subtitle: "Quelle question ce matin ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Le Code civil n'attend que vous." },
        { title: (name) => `Bienvenue ${name}`, subtitle: "Commençons cette matinée juridique." },
        { title: (name) => `Bonjour ${name}`, subtitle: "À votre service pour toute question de droit." },
        { title: (name) => `Bonjour ${name}`, subtitle: "Quelle problématique juridique aujourd'hui ?" },
    ],
    afternoon: [
        { title: (name) => `Bon après-midi, ${name}`, subtitle: "Une question de droit à résoudre ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Comment puis-je vous aider cet après-midi ?" },
        { title: (name) => `Content de vous voir, ${name}`, subtitle: "Quel dossier vous occupe ?" },
        { title: (name) => `Bon après-midi, ${name}`, subtitle: "Explorons ensemble vos questions." },
        { title: (name) => `Bonjour ${name}`, subtitle: "Prêt à approfondir un point de droit ?" },
        { title: (name) => `Bon après-midi, ${name}`, subtitle: "Je vous écoute." },
        { title: (name) => `Ravi de vous revoir, ${name}`, subtitle: "Quelle recherche cet après-midi ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Parlons droit." },
        { title: (name) => `Bon après-midi, ${name}`, subtitle: "Une jurisprudence à trouver ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Quelle question juridique vous anime ?" },
        { title: (name) => `À votre service, ${name}`, subtitle: "Explorons le droit ensemble." },
        { title: (name) => `Bon après-midi, ${name}`, subtitle: "Quel texte cherchez-vous ?" },
        { title: (name) => `Bonjour ${name}`, subtitle: "Votre assistant juridique est prêt." },
    ],
    evening: [
        { title: (name) => `Bonsoir ${name}`, subtitle: "Une question de droit ce soir ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Je suis à votre écoute." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Explorons le droit ensemble." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Quel sujet juridique vous préoccupe ?" },
        { title: (name) => `Bonne soirée, ${name}`, subtitle: "Comment puis-je vous assister ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Prêt pour une recherche juridique ?" },
        { title: (name) => `Content de vous voir, ${name}`, subtitle: "Quelle question ce soir ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Le droit n'attend pas." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "À votre service." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Parlons de votre dossier." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Une jurisprudence à éclaircir ?" },
        { title: (name) => `Ravi de vous retrouver, ${name}`, subtitle: "Quelle recherche ce soir ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Je vous écoute attentivement." },
    ],
    night: [
        { title: (name) => `Bonsoir ${name}`, subtitle: "Travail nocturne sur un dossier ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Je reste à votre disposition." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Une question urgente ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Le droit ne dort jamais." },
        { title: (name) => `Encore debout, ${name} ?`, subtitle: "Je suis là pour vous aider." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Quelle recherche tardive ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "À votre service, même la nuit." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Un point de droit à vérifier ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Je vous écoute." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Explorons ensemble votre question." },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Prêt pour une session nocturne ?" },
        { title: (name) => `Bonsoir ${name}`, subtitle: "Quel sujet vous tient éveillé ?" },
    ],
};

/**
 * Récupère un message d'accueil personnalisé
 * @param firstName Prénom de l'utilisateur
 * @param index Index du message (pour varier à chaque clic)
 * @returns Message d'accueil avec titre et sous-titre
 */
export const getWelcomeMessage = (firstName: string, index: number): WelcomeMessage => {
    const timeOfDay = getTimeOfDay();
    const messages = messagesByTime[timeOfDay];
    const messageIndex = index % messages.length;
    const message = messages[messageIndex];

    return {
        title: message.title(firstName || 'cher utilisateur'),
        subtitle: message.subtitle
    };
};

/**
 * Récupère le nombre total de messages disponibles pour le moment actuel
 */
export const getMessageCount = (): number => {
    const timeOfDay = getTimeOfDay();
    return messagesByTime[timeOfDay].length;
};

export type { WelcomeMessage };
